import { CardData } from "../CardData";
import { CardState } from "../db";

function getCurrentPromptIndex(
  cardData: CardData,
  cardState: CardState | null,
): number | null {
  if (cardData.cardType === "basic") {
    return null;
  } else {
    const { prompts } = cardData;
    return (cardState?.reviewCount || 0) % prompts.length;
  }
}

export default getCurrentPromptIndex;